import { Component, inject, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { CommonModule, NgFor } from '@angular/common'
import { IncomingPayroll } from '../../../store/payroll/payroll.state'

@Component({
  selector: 'app-key-settings',
  imports: [NgFor, CommonModule],
  templateUrl: './key-settings.component.html',
  styleUrl: './key-settings.component.scss'
})
export class KeySettingsComponent implements OnInit {
  private activeModal = inject(NgbActiveModal)
  @Input() payrollData!: IncomingPayroll
  compliancesListEntries: [string, boolean][] = []

  ngOnInit(): void {
    Object.entries(this.payrollData.salary.statutoryCompliances).forEach(v => {
      if (v[0] === 'employerCapping') {
        this.compliancesListEntries.push(['Employee Capping', v[1]])
      } else this.compliancesListEntries.push([v[0].toUpperCase(), v[1]])
    })
  }

  onClose(): void {
    this.activeModal.close()
  }
}
